const ActivateIntegration = require('./ActivateIntegration');

function GenericaEvents() {
  ActivateIntegration();
}

module.exports = {
  init: GenericaEvents,
  url: /^\/settings\/integracoes\/generica/,
}
